import React from "react";
import { useTranslation } from "react-i18next";

const NewsLetterComponent = () => {
    const { t } = useTranslation();

    return (
        <section className="section contact" id="contact">
            <div className="section-center contact-center">

                <article className="contact-title">
                    <h3>{t("newsletter.title")}</h3>
                    <p>{t("newsletter.description")}</p>
                </article>

                <form className="contact-form">
                    <input
                        style={{ marginBottom: "0rem" }}
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder={t("newsletter.placeholder_email")}
                    />
                    <button type="submit" className="btn-submit">
                        {t("newsletter.submit")}
                    </button>
                </form>
            </div>
        </section>
    );
};

export default NewsLetterComponent;
